module.exports = __webpack_public_path__ + "star-blueprint-deep.26540ed52da620765158.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/star-blueprint-deep.svg
// module id = ../../../../../src/assets/img/star-blueprint-deep.svg
// module chunks = main